module.exports = __webpack_public_path__ + "img/europe.7512c70e.png";